import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import useSWR from 'swr';
import { GUIDED_CONNECTION_WIDTHS } from '@hookdeck/theme';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import LINKS from '../../../../../configs/links';
import { getErrorCodeLabels } from '../../../../../utils/error-codes';
import { showChat } from '../../../../../utils/liveChat';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Skeleton from '../../../../common/base/Skeleton';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import { HeadersBlock } from '../../../../common/Data/Headers';
import DisplayDate from '../../../../common/DisplayDate';
import { Div } from '../../../../common/helpers/StyledUtils';
import JSONBrowser from '../../../../common/JSONBrowser';
import Modal from '../../../../common/Modal';
import { Status } from '../../../../common/Status';
import Table from '../../../../common/Table/Table';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { DashboardContext } from '../../DashboardContext';
import { EventMetadata } from '../../Event/EventOverview';
import { CLIOnboardingContext } from '../GuidedCLIOnboarding';
interface Props {
  context: CLIOnboardingContext;
  mutateContext: (input: Partial<CLIOnboardingContext>) => void;
  nextStep: () => void;
  is_current_step: boolean;
}
const InspectEvents: React.FC<Props> = t0 => {
  const $ = _c(56);
  const {
    context
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  useContext(DashboardContext);
  const {
    source,
    selected_event_id,
    setSelectedEventId
  } = context;
  const [active_tab, setActiveTab] = useState("headers");
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== source) {
    t1 = source ? APIMethodKeys.events.list({
      source_id: source.id,
      include: "data",
      limit: 50
    }) : null;
    $[0] = source;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.events || $[3] !== source?.id) {
    t2 = () => HookdeckAPI.events.list({
      source_id: source?.id,
      include: "data",
      limit: 50
    });
    $[2] = HookdeckAPI.events;
    $[3] = source?.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refreshInterval: 2000
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: events_response
  } = useSWR(t1, t2, t3);
  let events;
  let selected_event;
  let t4;
  let t5;
  if ($[6] !== events_response?.models || $[7] !== selected_event_id) {
    events = events_response?.models || [];
    let t6;
    if ($[12] !== selected_event_id) {
      t6 = event => event.id === selected_event_id;
      $[12] = selected_event_id;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    selected_event = events.find(t6);
    t4 = useSWR;
    t5 = selected_event && APIMethodKeys.attempts.list({
      event_id: selected_event.id
    });
    $[6] = events_response?.models;
    $[7] = selected_event_id;
    $[8] = events;
    $[9] = selected_event;
    $[10] = t4;
    $[11] = t5;
  } else {
    events = $[8];
    selected_event = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[14] !== HookdeckAPI.attempts || $[15] !== selected_event?.id) {
    t6 = () => HookdeckAPI.attempts.list({
      event_id: selected_event?.id
    });
    $[14] = HookdeckAPI.attempts;
    $[15] = selected_event?.id;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const {
    data: attempt_results,
    mutate: mutateAttempts
  } = t4(t5, t6);
  const attempt_to_fetch = attempt_results?.models[0];
  let t7;
  if ($[17] !== attempt_to_fetch) {
    t7 = attempt_to_fetch && APIMethodKeys.attempts.get(attempt_to_fetch.id);
    $[17] = attempt_to_fetch;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== HookdeckAPI.attempts || $[20] !== attempt_to_fetch?.id) {
    t8 = () => HookdeckAPI.attempts.get(attempt_to_fetch?.id as string);
    $[19] = HookdeckAPI.attempts;
    $[20] = attempt_to_fetch?.id;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const {
    data: attempt
  } = useSWR(t7, t8);
  let t9;
  if ($[22] !== attempt_results || $[23] !== mutateAttempts) {
    t9 = () => {
      if (attempt_results !== undefined) {
        mutateAttempts();
      }
    };
    $[22] = attempt_results;
    $[23] = mutateAttempts;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== attempt_results || $[26] !== mutateAttempts || $[27] !== selected_event) {
    t10 = [selected_event, attempt_results, mutateAttempts];
    $[25] = attempt_results;
    $[26] = mutateAttempts;
    $[27] = selected_event;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  useEffect(t9, t10);
  let t11;
  if ($[29] !== events || $[30] !== selected_event_id) {
    let t12;
    if ($[32] !== selected_event_id) {
      t12 = event_0 => ({
        id: event_0.id,
        selected: selected_event_id === event_0.id,
        fields: [<DisplayDate key={event_0.id} date={event_0.created_at} show_timezone={false} size="xs" />, <Status key={event_0.id} {...event_0} />, event_0.next_attempt_at ? <DisplayDate date={event_0.next_attempt_at} show_timezone={false} size="xs" /> : <Text muted={true} size="xs">-</Text>]
      });
      $[32] = selected_event_id;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    t11 = events.map(t12);
    $[29] = events;
    $[30] = selected_event_id;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const rows = t11;
  let t12;
  if ($[34] !== query.troubleshoot || $[35] !== updateSearchQuery) {
    t12 = query.troubleshoot && <Modal submit_label="Help" submit_icon="chat" onSubmit={showChat} title="Events troubleshooting" onClose={() => updateSearchQuery({}, {
      remove_keys: ["troubleshoot"]
    })}><Text m={{
        b: 4
      }}>Your events may not be showing for a variety of reasons:</Text><StyledCard p={4} m={{
        t: 4
      }}><Text bold={true} m={{
          b: 2
        }}>The sender implements a challenge to verify the Webhook URL</Text><Text muted={true}>Some webhook providers implement custom handshakes to verify the URL (also know as "Challenges"). Hookdeck will implement support for these handshakes on an ad-hoc basis when they are requested.{" "}<a href={LINKS.product_docs.inbuilt_source_support} target="_blank" rel="noreferrer">View the current list of supported platforms</a>.<br /><Button outline={true} m={{
            t: 3
          }} onClick={showChat}>Request a new one</Button></Text></StyledCard><StyledCard p={4} m={{
        t: 4
      }}><Text bold={true} m={{
          b: 2
        }}>The sender requires whitelisting our IP</Text><Text muted={true}>In some rare cases the providers might require you to whitelist Hookdeck IP's to send requests to our servers. You can whitelist Cloudflare IPs which are found{" "}<a href="http://cloudflare.com/ips/" target="_blank" rel="noreferrer">here</a>.</Text></StyledCard></Modal>;
    $[34] = query.troubleshoot;
    $[35] = updateSearchQuery;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      gap: 6
    };
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      px: GUIDED_CONNECTION_WIDTHS.step_container
    };
    t15 = {
      flexShrink: 0
    };
    $[38] = t14;
    $[39] = t15;
  } else {
    t14 = $[38];
    t15 = $[39];
  }
  let t16;
  if ($[40] !== rows || $[41] !== setSelectedEventId || $[42] !== updateSearchQuery) {
    t16 = <Div w={t14} style={t15}><StyledCard overflow_hidden={true}>{rows.length > 0 ? <StyledCardSection data-testid="guided-cli-preview-events-table"><Table widths={[0.3333333333333333, 0.3333333333333333, 0.3333333333333333]} headers={["Event Date", "Event Status", "Next Delivery Attempt"]} rows={rows} onRowSelected={row_id => setSelectedEventId(row_id || null)} table_body_style={{
            overflow: "auto"
          }} table_body_h={{
            px: 355
          }} /></StyledCardSection> : <StyledCardSection muted={true} flex={{
          align: "center",
          justify: "center",
          direction: "column",
          grow: true
        }} style={{
          position: "relative"
        }} h={{
          px: 324
        }}><Icon icon="loading" m={{
            b: 2
          }} /><Text semi={true}>Events will populate here</Text><Text muted={true} m={{
            b: 4
          }} w={{
            px: 410
          }} center={true}>The events you've triggered from your webhook producer will show here, once they reach the Hookdeck source URL. You should expect to see them within 1 minute of firing the event.</Text><Div style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0
          }} flex={{
            justify: "center"
          }} m={{
            b: 4
          }}><Button ghost={true} icon="help" muted={true} on="background" onClick={() => updateSearchQuery({
              troubleshoot: true
            })}>I'm still not seeing my events</Button></Div></StyledCardSection>}</StyledCard></Div>;
    $[40] = rows;
    $[41] = setSelectedEventId;
    $[42] = updateSearchQuery;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== active_tab || $[45] !== attempt || $[46] !== attempt_results || $[47] !== attempt_to_fetch || $[48] !== selected_event) {
    t17 = selected_event && <StyledCard w={{
      px: GUIDED_CONNECTION_WIDTHS.details_container
    }} h={{
      px: 386
    }} flex={{
      direction: "column",
      grow: true
    }} overflow_hidden={true}><StyledCardSection muted={true} p={{
        y: 1,
        x: 2
      }}><Text muted={true} semi={true} size="xs">Event Details</Text></StyledCardSection>{selected_event.error_code ? <><StyledCardSection p={{
          x: 4,
          y: 3
        }}><Text semi={true} size="s" m={{
            b: 1
          }}>Error</Text><Badge danger={true} subtle={true}>{selected_event.error_code}</Badge></StyledCardSection><StyledCardSection p={{
          x: 4,
          y: 3
        }} flex={{
          direction: "column",
          grow: true
        }}><Text semi={true} size="s" m={{
            b: 1
          }}>Description</Text><Text size="s">{getErrorCodeLabels()[selected_event.error_code]}</Text></StyledCardSection></> : <><StyledCardSection muted={true} p={{
          t: 2,
          x: 2
        }} style={{
          overflow: "visible"
        }}><Div style={{
            overflowX: "auto",
            overflowY: "hidden"
          }}><Tabs compact={true} border={false} active_tab={active_tab} style={{
              flexShrink: 0
            }} m={{
              b: 0.25
            }} onTabSelected={key => setActiveTab(key as 'headers' | 'request' | 'res_body' | 'metadata')} tabs={[{
              key: "headers",
              label: <Text semi={true} white_space="nowrap">Request Headers</Text>
            }, {
              key: "request",
              label: <Text semi={true} white_space="nowrap">Request Body</Text>
            }, {
              key: "res_body",
              label: <Text semi={true} white_space="nowrap">Response Body</Text>
            }, {
              key: "metadata",
              label: <Text semi={true} white_space="nowrap">Metadata</Text>
            }]} /></Div></StyledCardSection>{active_tab === "metadata" && <StyledCardSection p={{
          x: 4
        }} m={{
          b: -0.25
        }} flex={{
          grow: true,
          direction: "column"
        }} style={{
          overflow: "auto"
        }}><EventMetadata embedded={true} event={selected_event} webhook={null} attempts={attempt_results} onAttemptSelected={_temp} /></StyledCardSection>}{active_tab === "headers" && <StyledCardSection muted={true} p={4} flex={{
          grow: true,
          direction: "column"
        }} style={{
          overflow: "auto"
        }}><HeadersBlock headers={selected_event.data?.headers || {}} search_value="" /></StyledCardSection>}{active_tab === "request" && <StyledCardSection p={4} muted={true} flex={{
          grow: true,
          direction: "column"
        }} style={{
          overflow: "auto"
        }}>{attempt_to_fetch && !attempt || attempt?.body === "NOT_AVAILABLE_YET" ? <Skeleton h={{
            px: 200
          }} w={100} loading={true} /> : !attempt ? <Text muted={true}>Response will be shown once the delivery attempt has been made.</Text> : <JSONBrowser json={selected_event.data?.body as any || ""} compact={true} />}</StyledCardSection>}{active_tab === "res_body" && <StyledCardSection p={4} muted={true} flex={{
          grow: true,
          direction: "column"
        }} style={{
          overflow: "auto"
        }}>{attempt_to_fetch && !attempt || attempt?.body === "NOT_AVAILABLE_YET" ? <Skeleton h={{
            px: 200
          }} w={100} loading={true} /> : !attempt ? <Text muted={true}>Response body will be shown once the delivery attempt has been made.</Text> : <JSONBrowser json={attempt?.body as any || ""} compact={true} />}</StyledCardSection>}</>}</StyledCard>;
    $[44] = active_tab;
    $[45] = attempt;
    $[46] = attempt_results;
    $[47] = attempt_to_fetch;
    $[48] = selected_event;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== t16 || $[51] !== t17) {
    t18 = <Div flex={t13}>{t16}{t17}</Div>;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t12 || $[54] !== t18) {
    t19 = <>{t12}{t18}</>;
    $[53] = t12;
    $[54] = t18;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  return t19;
};
export default InspectEvents;
function _temp() {}